import React, { useCallback, useEffect, useState } from "react";
import { Avatar, Badge, Input, List, Space } from "antd";
import { MenuOutlined, SearchOutlined } from "@ant-design/icons";
import "./ChatterCss.css";
import ChatDetail from "./ChatDetail";
import { useSelector } from "react-redux";
import { RootState } from "../../store/store";

// Define the type for chat items
interface ChatItem {
  name: string;
  department: string;
  message: string;
  time: string;
  badge: number;
  isOnline: boolean;
}

const Chatter: React.FC<{ handleNotificationCountChange?: any }> = ({
  handleNotificationCountChange
}) => {
  const { auth, patients } = useSelector((state: RootState) => state);

  const rolesAbbreviation: any = {
    FO_STAFF: "FO",
    BO_STAFF: "BO",
    ADMIN: "ADMIN",
    "Mid Office Role": "MO",
    "Bill auditor": "BA",
    "Bill Approver": "BAP",
    "Portal Manager": "PM",
  };

  const userStr: any = localStorage.getItem("user");
  // const currentUserId = JSON.parse(userStr)?.id;
  // const currentUserId = localStorage.getItem("userName");
  const currentUserId =
    JSON.parse(userStr)?.firstname?.replace(/\s+/g, "-") +
    "-" +
    JSON.parse(userStr)?.lastname?.replace(/\s+/g, "-") +
    "-" +
    JSON.parse(userStr)?.id +
    "-" +
    (auth?.role?.role ? rolesAbbreviation[auth?.role?.role] : "");
  const jwtToken = auth.accessToken;
  const currentVisitId = patients?.fetchBasicDetails?.visitInfoResponse?.id;

  const [currentChat, setCurrentChat] = useState<ChatItem>({
    name: "Ramesh Kumar",
    department: "Front Desk",
    message: "Have a nice day",
    time: "08:15 PM",
    badge: 8,
    isOnline: true,
  });

    
  // const [notificationCount, setNotificationCount] = useState(0);

  // // Propagate notification count changes up
  // const handleNotificationCountChange = useCallback((count: number) => {
  //   setNotificationCount(count);
  //   onChatNotificationCount?.(count);

  //   // Also dispatch custom event to sync with FloatingDrawer
  //   window.dispatchEvent(
  //     new CustomEvent("gseven:chat:unread", {
  //       detail: { type: "chat:notification:count", count }
  //     })
  //   );
  // }, [onChatNotificationCount]);


  useEffect(() => {
    if (auth?.role?.role) {
      const patientName = auth?.userName;
      const department =
        auth?.role?.role == "FO_STAFF"
          ? "GSEVENPRO FRONT DESK "
          : auth?.role?.role == "BO_STAFF"
          ? "GSEVENPRO BACK OFFICE "
          : auth?.role?.role == "ADMIN"
          ? "GSEVENPRO ADMIN"
          : auth?.role?.role == "Mid Office Role"
          ? "GSEVENPRO MID OFFICE "
          : auth?.role?.role == "Bill auditor"
          ? "GSEVENPRO BILL AUDITOR"
          : auth?.role?.role == "Bill Approver"
          ? "GSEVENPRO BILL APPROVER"
          : auth?.role?.role == "Portal Manager"
          ? "GSEVENPRO PORTAL MANAGER"
          : " ";
      if (patientName) {
        setCurrentChat((prevChat) => ({
          ...prevChat,
          name: patientName,
          department: department,
        }));
      }
    }
  }, [auth]);

  return (
    <div style={{ height: "100%" }}>
      {/* {currentChat ? (
        <ChatDetail chat={currentChat} onBack={() => setCurrentChat(null)} />
      ) : (
        <div style={{ height: "100%" }} className="chatter">
          <div
            style={{
              marginBottom: 4,
              display: "flex",
              gap: "10px",
              borderBottom: "1px solid #D9D9D9",
              padding: "10px 17px",
            }}
          >
            <Input
              prefix={<SearchOutlined />}
              placeholder="Search"
              style={{
                borderRadius: "10px",
                backgroundColor: "#fff",
                border: "1px solid #D9D9D9",
                height: "45px",
              }}
            />
            <MenuOutlined style={{ padding: "8px" }} />
          </div>

          <List
            dataSource={chatData}
            style={{ padding: "0px 20px" }}
            renderItem={(item) => (
              <List.Item
                style={{
                  display: "flex",
                  alignItems: "center",
                  padding: "10px 0",
                  cursor:"pointer"
                }}
                onClick={() => setCurrentChat(item)}
              >
                <Space style={{ flex: 1 }}>
                  <div style={{ position: "relative" }}>
                    <Avatar size="large" style={{ backgroundColor: "#008B8B" }}>
                      {item.name.charAt(0)}
                    </Avatar>
                    {item.isOnline && (
                      <span
                        style={{
                          position: "absolute",
                          bottom: "-4px",
                          right: "-2px",
                          width: "15px",
                          height: "15px",
                          backgroundColor: "#60D669",
                          borderRadius: "50%",
                          border: "2px solid white",
                        }}
                      />
                    )}
                  </div>

                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "0px",
                    }}
                  >
                    <div
                      style={{
                        fontWeight: 600,
                        fontSize: "16px",
                        textTransform: "initial",
                        lineHeight: "20px",
                      }}
                    >
                      {item.name}
                    </div>
                    <div
                      style={{
                        fontSize: "14px",
                        color: "#575757",
                        textTransform: "initial",
                        lineHeight: "17px",
                      }}
                    >
                      {item.department}
                    </div>
                    <div
                      style={{
                        fontSize: "15px",
                        color: "#575757",
                        textTransform: "initial",
                      }}
                    >
                      {item.message}
                    </div>
                  </div>
                </Space>
                <div style={{ textAlign: "right" }}>
                  <div
                    style={{
                      color: "#575757",
                      fontSize: "12px",
                      fontWeight: "600",
                    }}
                  >
                    {item.time}
                  </div>
                  {item.badge > 0 && (
                    <div
                      style={{
                        marginTop: "4px",
                        color: "white",
                        backgroundColor: "#008B8B",
                        fontSize: "12px",
                        fontWeight: 500,
                        height: "20px",
                        width: "20px",
                        lineHeight: "20px",
                        borderRadius: "50%",
                        textAlign: "center",
                        display: "inline-block",
                      }}
                    >
                      {item.badge}
                    </div>
                  )}
                </div>
              </List.Item>
            )}
          />
        </div>
      )} */}

      <ChatDetail
        chat={currentChat}
        currentUserId={currentUserId}
        jwtToken={jwtToken}
        visitId={currentVisitId}
        patientDetails={patients?.fetchBasicDetails}
        onNotificationCountChange={handleNotificationCountChange}
      />
    </div>
  );
};

export default Chatter;
